var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pa1 pa3-l layout"},[_c('state-stats'),_c('closed-stats'),(false)?_c('current-stats'):_vm._e(),_vm._v(" "),_c('closed-with-warnings'),_c('user-duties-ex'),_c('average-duration'),_c('average-invited')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }